/**
 * Retrieves the content attribute of a meta tag with the specified name.
 *
 * @param metaTagName - The name attribute value of the meta tag to find
 * @returns The content attribute value if the meta tag is found, undefined otherwise
 *
 * @example
 * // Given meta tag:
 * // <meta name="a2z:mons_weblab_treatment" content="FEATURE_A=T1">
 * const content = getMetaTagContent('a2z:mons_weblab_treatment');
 * // Returns: "FEATURE_A=T1"
 *
 * @see META_TAG for available meta tag names
 * @see https://w.amazon.com/bin/view/Mons/Weblab/Configuration for weblab meta tag format
 */
export const getMetaTagContent = (metaTagName: string) => document.head
  .querySelector(`meta[name="${metaTagName}"]`)?.getAttribute('content');
